import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import MedicalClaimList from "./MedicalClaimList";
import MedicalClaimListPrevious from "./MedicalClaimListPrevious";
const axios = require("axios");
const ref = React.createRef();
class MedicalDetailSelf extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none"};
    }    
    render(){
        return(
            <div className="containera1">
                <br/>
                    <div style={{height:"60px"}}>
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none" }); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block" });                                                            
                            }}
                            >
                            <Tab label="Current year" > </Tab> 
                            <Tab label="Previous year"></Tab>
                        </Tabs>
                    </div>
                    <div  style={{display:this.state.tab1}}>
                            <MedicalClaimList/>
                    </div>

                    <div  style={{display:this.state.tab2}}>
                        <MedicalClaimListPrevious/>
                    </div>
                    <br/><br/>
            </div>
    )}
}
export default MedicalDetailSelf;